export const HEADER_BANNER_STYLES = { counter: "counter", marquee: "marquee" };

// Set on <html> while the strip is shown; sticky elements under the header offset by it.
export const HEADER_BANNER_HEIGHT_VAR = "--header-banner-height";

// Design values, used when the admin leaves a colour empty (Magento then omits the field).
export const HEADER_BANNER_DEFAULT_COLORS = {
  background: "#F97316",
  text: "#FFFFFF",
  digitBox: "#EA580C",
  button: "#FFFFFF",
  buttonText: "#00269A",
};

// Used when Magento sends no speed.
export const HEADER_BANNER_MARQUEE_SPEED_PX_PER_S = 60;

// Magento applies start_at server-side, so an open page only learns that a banner started by
// asking again. The MW caches for 60 s; polling faster than that would return the same answer.
export const HEADER_BANNER_REFRESH_MS = 5 * 60 * 1000;

// setTimeout overflows above 2^31 - 1 ms (~24.8 days) and would fire at once.
export const MAX_TIMEOUT_MS = 2147483647;
